import React, {
  useContext,
  useEffect,
  useMemo,
  useState,
  useCallback,
} from "react";
import styles from "./UserCard.module.scss";

import { CgChevronUpO, CgChevronDownO } from "react-icons/cg";
import { MdOutlineMailOutline, MdVpnKey } from "react-icons/md";
import { BsPatchExclamation } from "react-icons/bs";

import NavContext from "../../../context/NavContext";
import Axios from "../../../_services/caller.service";

import InputForms from "../../UiComponents/forms/InputForms";
import { PermissionGate } from "../../superAdmin/managePermissions/PermissionGate";

import DeleteUser from "./DeleteUser";
import { GreenLed, RedLed, YellowLed } from "./Led";

import Modal from "../../UiComponents/modals/Modal";
import WarningAdminModal from "../../UiComponents/modals/WarningAdminModal";
import useModal from "../../../hooks/useModal";

import SendEmailConfirmationAccessHS from "../sendEmailConfirmation/SendEmailConfirmationAccessHS";
import { useTranslation } from "react-i18next";
import { isValidRole, DEFAULT_ROLE } from "../../../utils/constant/roles";
const UserCard = ({
  inviteUser = [],
  setSorted,

  displayRoleByUser,
  selectDefaultValue,
  setUpdateRole,
  inviteId = [],
  userAuth,
  setMaj,
  maj,
  majRole,
  setMajRole,
ownerIdOverride,
  numberCabsAuth,
  onResetPassword,
  hideEmailConfirmation = false,
}) => {
  const { ownerId, adminProfile, superAdmin, owner } = useContext(NavContext);
  const { t } = useTranslation();
const resolvedOwnerId = ownerIdOverride ?? ownerId;
  // ===== UI =====
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [openDetails, setOpenDetails] = useState(false);
  const [showEmailId, setShowEmailId] = useState(null);

  // ===== detail =====
  const [cabAuth, setCabAuth] = useState(false); // backend value for "all cab"
  const [localAllCab, setLocalAllCab] = useState(false);
  const [localCabAuth, setLocalCabAuth] = useState({}); // cabId -> bool

  const [refresh, setRefresh] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const { isShowing, toggle } = useModal();

  const [currentSort, setCurrentSort] = useState(null);
  const handleSort = useCallback((col) => {
    const asc = `asc${col}`;
    const dsc = `dsc${col}`;
    const next = currentSort === asc ? dsc : asc;
    setCurrentSort(next);
    setSorted?.(next);
  }, [currentSort, setSorted]);

  const renderSortChevron = (col) => {
    const asc = `asc${col}`;
    const dsc = `dsc${col}`;
    const isDsc = currentSort === dsc;
    const isActive = currentSort === asc || currentSort === dsc;
    const Icon = isDsc ? CgChevronDownO : CgChevronUpO;
    return (
      <Icon
        className={`${styles.arrow} ${!isActive ? styles.arrowInactive : ""}`}
        onClick={(e) => { e.stopPropagation(); handleSort(col); }}
      />
    );
  };

  const stop = useCallback((e) => {
    e.stopPropagation();
  }, []);

  const selectedUser = useMemo(() => {
    if (!selectedUserId) return null;
    return (
      inviteUser.find((u) => String(u.ID ?? u.id) === String(selectedUserId)) ||
      null
    );
  }, [inviteUser, selectedUserId]);

  const selectedUserCabines = useMemo(() => {
    return selectedUser?.cabines?.[0] || [];
  }, [selectedUser]);

  const checkIfOneCabIsAuth = (userRoleId) => {
    return displayRoleByUser?.(userRoleId) === t("team.no_right");
  };

  // ✅ Toggle on row click (mais PAS sur la section details)
  const toggleUserDetails = (u) => {
    const id = u.ID ?? u.id;
    console.log("toggleUserDetails called for user:", id, "selectedUserId:", selectedUserId, "openDetails:", openDetails);

    if (String(id) === String(selectedUserId)) {
      console.log("Same user clicked - toggling openDetails");
      setOpenDetails((v) => !v);
      return;
    }

    console.log("Different user clicked - opening details");
    setSelectedUserId(id);
    setOpenDetails(true);
    setSearchTerm("");
  };

  // ===== Fetch all-cab auth for selected user (backend truth)
  useEffect(() => {
    if (!selectedUserId || !openDetails) return;

    Axios.post(`/allCabAreAuth/${resolvedOwnerId}`, {
      data: { updateUserId: selectedUserId },
    })
      .then((response) => setCabAuth(!!response.data.data))
      .catch(console.log);
  }, [refresh, resolvedOwnerId, selectedUserId, openDetails]);

  // sync localAllCab from backend truth (when refreshed)
  useEffect(() => {
    setLocalAllCab(!!cabAuth);
  }, [cabAuth]);

  // sync localCabAuth from selected user cab list (when refreshed)
  useEffect(() => {
    const next = {};
    selectedUserCabines.forEach((cab) => {
      next[cab.id] = !!cab.auth;
    });
    setLocalCabAuth(next);
  }, [selectedUserCabines]);

  // ✅ counts based on local state (instant UI)
  const totalCabs = selectedUserCabines.length;

  const activeCabs = useMemo(() => {
    return Object.values(localCabAuth).filter(Boolean).length;
  }, [localCabAuth]);

  // ✅ keep localAllCab consistent with cab-by-cab
  useEffect(() => {
    if (!openDetails) return;
    if (totalCabs === 0) {
      setLocalAllCab(false);
      return;
    }
    setLocalAllCab(activeCabs === totalCabs);
  }, [activeCabs, totalCabs, openDetails]);

  // ===== API calls (reliable: userId+cabs passed directly)
  const apiSetAllCab = async ({ userId, checked }) => {
    if (!resolvedOwnerId || !userId) return;

    if (checked) {
      await Axios.post(`/createPermissionsAllCab/${resolvedOwnerId}`, {
        data: { updateUserId: userId },
      });
    } else {
      await Axios.delete(
        `/deletePermissionsAllCab/${resolvedOwnerId}?userId=${userId}`,
      );
    }
  };

  const apiSetCabByCab = async ({ userId, cabId, checked }) => {
    if (!resolvedOwnerId || !userId || !cabId) return;

    if (checked) {
      const currentRole = Number(selectDefaultValue?.(userId));
      const role = isValidRole(currentRole) ? currentRole : DEFAULT_ROLE;
      await Axios.post(`/createPermissionsCabByCab/${resolvedOwnerId}`, {
        updateUserId: userId,
        cabId,
        role,
      });
    } else {
      await Axios.delete(
        `/deletePermissionsCabByCab/${resolvedOwnerId}?userId=${userId}&cabid=${cabId}`,
      );
    }
  };

  // ===== Handlers
  const handleChangeAllCab = async (e, userId) => {
    const checked = e.target.checked;

    // optimistic: toggle all
    setLocalAllCab(checked);
    setLocalCabAuth((prev) => {
      const next = { ...prev };
      selectedUserCabines.forEach((cab) => (next[cab.id] = checked));
      return next;
    });

    try {
      await apiSetAllCab({ userId, checked });
      setRefresh((r) => !r);
      setMajRole?.(!majRole);
      setMaj?.(!maj);
    } catch (err) {
      console.log(err);
      // refresh backend truth will fix UI
      setRefresh((r) => !r);
    }
  };

  const handleChangeCabByCab = async (e, userId, cabId) => {
    const checked = e.target.checked;

    // optimistic
    setLocalCabAuth((prev) => ({ ...prev, [cabId]: checked }));
    if (!checked) setLocalAllCab(false);

    try {
      await apiSetCabByCab({ userId, cabId, checked });
      setRefresh((r) => !r);
      setMajRole?.(!majRole);
      setMaj?.(!maj);
    } catch (err) {
      console.log(err);
      setRefresh((r) => !r);
    }
  };

  // ===== Role select
  const updateUserRoleWithSelect = async (e, userId) => {
    const value = e.target.value;

    // ouverture modal admin si besoin
    if (value === "256") {
      toggle();
      return;
    }

    // ✅ update local state si tu veux (optionnel)
    setUpdateRole?.(value);

    // ✅ appel API direct : role unique pour TOUTES les cabines
    try {
      await Axios.put(`/updateRole/${resolvedOwnerId}`, {
        data: {
          updateUserId: userId,
          updateRole: value,
          inviteId: Array.isArray(inviteId) ? inviteId : [],
        },
      });

      // refresh data (roles + users)
      setMajRole?.(!majRole);
      setMaj?.(!maj);
    } catch (err) {
      console.log(err);
    }
  };

  const updateRoleInAdmin = async () => {
    try {
      await Axios.put(`/updateRole/${resolvedOwnerId}`, {
        data: {
          updateUserId: selectedUserId,
          updateRole: "256",
          inviteId: Array.isArray(inviteId) ? inviteId : [],
        },
      });

      setMajRole?.(!majRole);
      setMaj?.(!maj);
      toggle();
    } catch (err) {
      console.log(err);
    }
  };

  const filteredCabinesInCabByCab = useMemo(() => {
    const list = Array.isArray(selectedUserCabines) ? selectedUserCabines : [];
    const q = (searchTerm || "").toLowerCase();
    return list.filter((cab) => (cab.cabname || "").toLowerCase().includes(q));
  }, [selectedUserCabines, searchTerm]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.table}>
        {/* ================= HEADER ================= */}
        <div className={styles.headerRow}>
          <div className={styles.th}>
            <span>{t("team.header_login")}</span>
            {renderSortChevron("Login")}
          </div>

          <div className={styles.th}>
            <span>{t("team.header_name")}</span>
            {renderSortChevron("Name")}
          </div>

          <div className={styles.th}>{t("team.header_email")}</div>
          <div className={styles.th}>{t("team.header_rights")}</div>
          <div className={`${styles.th} ${styles.hideSm}`}>{t("team.header_cabines")}</div>
        </div>

        {/* ================= BODY ================= */}
        <div className={styles.body}>
          {inviteUser.map((u) => {
            const id = u.ID ?? u.id;
            const isOpen = String(id) === String(selectedUserId) && openDetails;

            const login = u.user_login || u.login || "-";
            const email = u.user_email || u.email || "";
            const firstName = u.first_name || "";
            const lastName = u.last_name || "";
            const displayName = u.display_name || "";

            const fullName =
              lastName || firstName
                ? `${lastName} ${firstName}`.trim()
                : displayName || "-";

            const roleLabel = displayRoleByUser?.(u.ID) ?? t("team.no_right");
            const cabCountBackend = numberCabsAuth?.(u.ID) ?? 0;
            const totalCabsBackend = u?.cabines?.[0]?.length || 0;
            const isOwner = String(id) === String(resolvedOwnerId);

            return (
              <div key={id} className={styles.rowWrap}>
                {/* ===== ROW ===== */}
                <div
                  className={`${styles.row} ${isOpen ? styles.activeRow : ""} ${isOwner ? styles.ownerRow : ""}`}
                  onClick={(e) => {
                    console.log("🔴 Row clicked - calling toggleUserDetails");
                    toggleUserDetails(u);
                  }}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => e.key === "Enter" && toggleUserDetails(u)}
                >
                  <div className={styles.td}>{login}</div>

                  <div className={styles.td} title={fullName}>
                    <span className={isOwner ? styles.ownerName : ""}>{fullName}</span>
                  </div>

                  <div className={styles.td}>
                    {email ? (
                      <button
                        className={styles.mailBtn}
                        onMouseDown={stop}
                        onClick={(e) => {
                          stop(e);
                          const subject = encodeURIComponent(
                            t("team.email_subject_admin_rights"),
                          );
                          window.location.href = `mailto:${email}?subject=${subject}`;
                        }}
                        onMouseEnter={() => setShowEmailId(id)}
                        onMouseLeave={() => setShowEmailId(null)}
                        title={email}
                      >
                        <MdOutlineMailOutline className={styles.mailIcon} />
                        Email
                      </button>
                    ) : (
                      <span className={styles.muted}>—</span>
                    )}
                  </div>

                  <div className={styles.td}>
                    {isOwner ? (
                      <span className={styles.ownerBadge}>Owner</span>
                    ) : (
                      <span className={styles.badge}>{roleLabel}</span>
                    )}
                  </div>

                  <div className={`${styles.td} ${styles.hideSm}`}>
                    {isOwner ? (
                      <span className={styles.muted}>
                        {totalCabsBackend}/{totalCabsBackend}
                      </span>
                    ) : (
                      <span className={styles.muted}>
                        {cabCountBackend}/{totalCabsBackend}
                      </span>
                    )}
                  </div>
                </div>

                {/* ===== DETAILS ===== */}
                {isOpen && (
                  <div
                    className={styles.details}
                    onMouseDown={(e) => {
                      console.log("✅ Details onMouseDown - stopping propagation");
                      stop(e);
                    }}
                    onClick={(e) => {
                      console.log("✅ Details onClick - stopping propagation");
                      stop(e);
                    }}
                  >
                    {!isOwner && checkIfOneCabIsAuth(u.ID) && (
                      <div className={styles.oneCabMessage}>
                        <BsPatchExclamation
                          style={{ color: "orange", fontSize: 18 }}
                        />
                        <span>
                          {t("team.authorize_cabine_message")}
                        </span>
                      </div>
                    )}

                    <div className={`${styles.detailsBar} ${isOwner ? styles.ownerDetailsBar : ""}`}>
                      {/* DROITS */}
                      {!isOwner && (
                        <div className={styles.detailsItem}>
                          {activeCabs > 0 && (
                            <select
                              className={styles.selectCompact}
                              onChange={(e) => updateUserRoleWithSelect(e, u.ID)}
                              value={selectDefaultValue?.(u.ID)}
                            >
                              <option value="1">{t("team.consultation")}</option>
                              <option value="8">{t("team.calibration_role")}</option>
                              {(superAdmin || owner === true) && (
                                <option value="256">{t("team.admin_role")}</option>
                              )}
                            </select>
                          )}
                        </div>
                      )}

                      {/* ALL CAB */}
                      {!isOwner && (
                        <div className={styles.detailsItem}>
                          <label
                            className={styles.switchCompact}
                            title={t("team.authorize_all_cabines")}
                          >
                            <input
                              id={`switchAll-${id}`}
                              type="checkbox"
                              checked={localAllCab}
                              onChange={(e) => handleChangeAllCab(e, u.ID)}
                            />
                            <span className={styles.smallLabel}>
                              {t("team.all_cabines")}
                            </span>
                          </label>
                        </div>
                      )}

                      {/* LED — basé sur LOCAL (reflet immédiat) */}
                      {!isOwner && (
                        <div className={styles.detailsItem}>
                          <div className={styles.ledCompact}>
                            {activeCabs === 0 && (
                              <RedLed Children={`${activeCabs}/${totalCabs}`} />
                            )}
                            {activeCabs === totalCabs && totalCabs > 0 && (
                              <GreenLed Children={`${activeCabs}/${totalCabs}`} />
                            )}
                            {activeCabs !== totalCabs && activeCabs !== 0 && (
                              <YellowLed
                                Children={`${activeCabs}/${totalCabs}`}
                              />
                            )}
                          </div>
                        </div>
                      )}

                      {/* ACTIONS */}
                      <div className={styles.detailsItemRight}>
                        {superAdmin && !hideEmailConfirmation && (
                          <div
                            className={styles.blockFull}
                          >
                            <SendEmailConfirmationAccessHS
                              login={login}
                              userMail={email}
                            />
                          </div>
                        )}

                        {onResetPassword && (
                          <button
                            type="button"
                            className={styles.btnAction}
                            aria-label={t("team.reset_password")}
                            onClick={(e) => {
                              stop(e);
                              onResetPassword(id, displayName || login, email);
                            }}
                          >
                            <MdVpnKey />
                            {t("team.reset_password_short")}
                          </button>
                        )}

                        {!isOwner && (
                          <div
                            className={styles.btnActionDanger}
                            title={t("team.delete_label")}
                          >
                            <DeleteUser
                              name={u.name || u.first_name}
                              lastName={u.last_name}
                              userId={u.ID}
                              ownerId={resolvedOwnerId}
                              setMaj={setMaj}
                              onDeleteSuccess={() => {
                                setOpenDetails(false);
                                setSelectedUserId(null);
                              }}
                            />
                          </div>
                        )}
                      </div>
                    </div>

                    {/* SEARCH + CAB LIST */}
                    {!isOwner && (
                      <div
                        className={styles.blockFull}
                      >
                        <InputForms
                          id={styles.inputSearchCabByCab}
                          placeholder={t("team.search_cabine")}
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                        />

                        <div className={styles.cabList}>
                          {filteredCabinesInCabByCab.map((cab) => (
                            <div key={cab.id} className={styles.cabRow}>
                              <div className={styles.cabName}>{cab.cabname}</div>

                              <div
                                className={styles.cabAction}
                              >
                                <span>{t("team.authorize")}</span>
                                <input
                                  id={`switchOne-${cab.id}-${u.ID}`}
                                  type="checkbox"
                                  checked={!!localCabAuth[cab.id]}
                                  onChange={(e) =>
                                    handleChangeCabByCab(e, u.ID, cab.id)
                                  }
                                />
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}

                    <Modal
                      isShowing={isShowing}
                      hide={toggle}
                      children={
                        <WarningAdminModal
                          name={u.name}
                          lastName={u.last_name}
                          updateRoleInAdmin={updateRoleInAdmin}
                        />
                      }
                    />
                  </div>
                )}
              </div>
            );
          })}

          {inviteUser.length === 0 && (
            <div className={styles.empty}>{t("team.no_user")}</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default UserCard;
